module.exports = __webpack_public_path__ + "img/dkjl.251d53b8.png";